import React from 'react';
import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { buttonBaseStyles as buttons } from 'styles/designConstants';

const useStyles = makeStyles({
  root: {
    ...buttons.root,
    fontSize: (props: IOwnProps) => props.fontSize || 13,
    height: (props: IOwnProps) => props.height || 34,
    lineHeight: (props: IOwnProps) => props.lineHeight || '13px',
    margin: (props: IOwnProps) => props.margin || 0,
    width: (props: IOwnProps) => props.width || 80,
  },
  // Button roles, as identified in the design palette
  primary: buttons.primary,
  secondary: buttons.secondary,
  negative: buttons.negative,
  dashboard: buttons.dashboard,
  graphInfo: buttons.graphInfo,
});

const ButtonSmall = (props: IOwnProps) => {
  const classes = useStyles(props);
  let buttonRoleStyle;

  switch (props.buttonRole) {
    case 'secondary':
      buttonRoleStyle = classes.secondary;
      break;
    case 'negative':
      buttonRoleStyle = classes.negative;
      break;
    case 'dashboard':
      buttonRoleStyle = classes.dashboard;
      break;
    case 'graphInfo':
      buttonRoleStyle = classes.graphInfo;
      break;
    default:
      buttonRoleStyle = classes.primary;
  }

  return (
    <ButtonBase
      className={`${classes.root} ${buttonRoleStyle}`}
      onClick={props.handleClick}
      disabled={props.disabled}
      data-testid={props['data-testid']}
      focusRipple
    >
      {props.children}
    </ButtonBase>
  );
};

export interface IOwnProps {
  buttonRole: string; // chose from 'primary'(default), 'secondary', or 'negative'.
  children: any;
  disabled?: boolean;
  handleClick?: () => void;
  margin?: string;
  width?: string;
  fontSize?: string;
  lineHeight?: string;
  height?: string;
  'data-testid'?: string;
}

export default ButtonSmall;
